import type { FeedbackFeature } from "@/model/feedback";

import { webEvent } from "./event";

// When the user clicks the feedback button of a feature
export const feedbackButtonClicked = (feature: FeedbackFeature) =>
  webEvent("feedback", "button_clicked", { feature });

// When the user sends the feedback dialog
export const feedbackSent = (feature: FeedbackFeature) => webEvent("feedback", "sent", { feature });

// When the user closes the feedback dialog without sending
export const feedbackDismissed = (feature: FeedbackFeature) =>
  webEvent("feedback", "dismissed", { feature });
